import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkUpdateVisibilityDocument,
  BulkUpdateVisibilityMutation,
  BulkUpdateVisibilityMutationVariables,
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useBulkUpdateVisibilityDocument = ({
  fromDataTable = false,
}: {
  fromDataTable?: boolean
}) => {
  const client = useApolloClient()
  const [bulkUpdateVisibilityMutation, { loading }] = useMutation(BulkUpdateVisibilityDocument, {
    extractorFn: (data: BulkUpdateVisibilityMutation) =>
      data.documentsMutations.bulkUpdateVisibilityDocumentsDocument,
  })

  return {
    loading,
    async bulkUpdateVisibility(variables: BulkUpdateVisibilityMutationVariables) {
      const result = await bulkUpdateVisibilityMutation({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useBulkUpdateVisibilityDocument
